import DataContainer from "components/utility/data-container/DataContainer";
import CoveoEngine from "./CoveoEngine";

const CoveoContainer = ({ dataset }) => {
	const pageType = window.dataLayer[0].title;
	if (window[`coveoSearchData_${dataset.uniqueid}`]) {
		return (
			<DataContainer data={`coveoSearchData_${dataset.uniqueid}`}>
				<CoveoEngine dataset={dataset} pageType={pageType} />
			</DataContainer>
		);
	}
	return <></>;
};

export default CoveoContainer;
